import { render } from "./SiteMenu.vue?vue&type=template&id=7bdc4d9a&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"

import "./SiteMenu.vue?vue&type=style&index=0&id=7bdc4d9a&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdc4d9a"]])

export default __exports__